// extracted by mini-css-extract-plugin
export default {"oDataGridPage":"ODataGridPage_oDataGridPage__YQ6ml"};